// Display helpers shared by the filter chips and renderers.

/** "2026-03-04" -> "4 Mar 2026" (local date, no timezone shift). */
export const formatDate = (iso) => {
    if (!iso) return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};

/** Local yyyy-mm-dd for `days` from today (negative = past). */
export const isoDay = (days = 0) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** Standard Active / Inactive options for 1/0 status columns. */
export const STATUS_OPTIONS = [
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
];
